<template>
  <div>
    <div class="chunk" :id="intro_id">
      <div class="chunk-text">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntroCard",
  props: {
    text: String,
    intro_id: String,
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.chunk {
  background-color: rgba(30, 30, 30, 1);
  border-radius: 8px;
  padding: 15px 52px 15px 20px;
  transition: 0.3s ease-in-out;
  margin-bottom: 5px;
}
.chunk-text {
  font-family: Inter;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: rgb(255, 255, 255);
  transition: 0.3s ease-in-out;
  opacity: 0.3;
}
</style>